import styled from '@emotion/styled';
import { ObjectId } from '@racemap/sdk/schema/base';
import { MaxMobileWindowWidth } from '@racemap/utilities/consts/common';
import TestSelectors from '@racemap/utilities/consts/test_selectors';
import { type FC, useEffect } from 'react';
import { TrackerManagerDesktop, TrackerManagerMobile } from '../../components/TrackerManager';
import { useTrackerIdsFromUrl } from '../../components/TrackerManager/Tables/useTrackerIdsFromUrl';
import { useInterval, useIsMobile } from '../../lib/customHooks';
import { useStore } from '../../store/reducers';

export const TrackerManagerView: FC = () => {
  const { loadData } = useStore((s) => s.trackers.actions);
  const isMobile = useIsMobile();

  useInterval(async () => {
    await loadData(isMobile);
  }, 10000);

  const { replaceSample } = useStore((s) => s.trackers.actions);
  const trackerIds = useTrackerIdsFromUrl();

  useEffect(() => {
    if (trackerIds.length > 0) {
      const mappedIds = trackerIds.map((id: string) => new ObjectId(id));
      replaceSample(mappedIds);
    }
  }, [replaceSample, trackerIds]);

  return (
    <Container id={TestSelectors.admin.trackers.container.toString()}>
      {isMobile ? <TrackerManagerMobile /> : <TrackerManagerDesktop />}
    </Container>
  );
};

const Container = styled.div`
  position: absolute;
  padding: 10px;
  top: 50px;
  bottom: 0;
  left: 0;
  right: 0;

  @media (max-width: ${MaxMobileWindowWidth}px) {
    padding: 0px;
  }
`;
